import {
  CREATE_CATEGORY,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_ERROR,
} from './../../../actionType.js'

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
}

const CreateCategory = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CATEGORY:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      }
      break

    case CREATE_CATEGORY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      }
      break

    case CREATE_CATEGORY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default CreateCategory
